// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__GX6uf","emails":"CreateEditClinics_emails__1naqn","emailTagLabel":"CreateEditClinics_emailTagLabel__1sWEf"};